import "./contact.css";
import React from "react";
import {useNavigate} from "react-router-dom";

const FavoritesPage = () => {
  const navigate = useNavigate();

  const redirectToBack = () => {
    navigate(-1);
  };

  return (
    <section id="contact" className="section">
      <div className="section">
        <div className="contact__page_wrapper">
          <div className="contact__page">
            <h2 className="contact__page_title">Kontakt z nami</h2>

            <div className="contact__logo_wrapper">
              <img
                className="contact__logo"
                src={require("./img/image.png")}
                alt="contact__logo"
              />
            </div>
            <div id="contact__text" className="contact__page_text">
              <p className='contact__page_text--description'>
                Dostawcą usług jest Propulse FZCO, IFZA Business Park, DDP, 001 - 26165, Dubai Silicon Oasis, Dubai,
                United Arab Emirates
              </p>
              {/* <p>
                <strong>Phone:</strong> +359 24928370
              </p> */}
              <p className='contact__page_text--description'>
                <strong>Email:</strong> cc.pl@propulse.website
              </p>
            </div>

            <button className="contact__page_button" onClick={redirectToBack}>
              Wstecz
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FavoritesPage;
